var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userAcknowledgement())?_vm._m(0):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer grid-item span-cols",domProps:{"innerHTML":_vm._s(_vm.userAcknowledgement())}})
}]

export { render, staticRenderFns }